
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { getGoodsFileCategory } from "@/api/ccxIntegratedService";
import {
  getStoreOfflineCategoryShop,
  getStoreIngredientCategoryShop,
} from "@/api/shouyin";
@Component
export default class CategorySelect extends Vue {
  @Getter companyId!: string;
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;

  @Prop({
    default: () => {
      return { categoryName: "全部分类", categoryId: "all" };
    },
  })
  defaultValue?: Record<string, string>;
  @Prop({ default: "门店" }) dimension?: string; // 门店 微店
  shopTreeData: any = [
    {
      categoryName: "门店商品",
      categoryId: "1",
      children: [
        {
          categoryId: "",
          categoryName: "全部",
          categoryType: 1,
          children: [
            {
              categoryId: "",
              categoryName: "全部",
              categoryType: 1,
            },
          ],
        },
      ],
      categoryType: 1,
    },
  ];
  weidianTreeData: any = [
    {
      categoryName: "微店商品",
      categoryId: "0",
      children: [
        {
          categoryId: "",
          categoryName: "全部",
          categoryType: 2,
          children: [
            {
              categoryId: "",
              categoryName: "全部",
              categoryType: 2,
            },
          ],
        },
      ],
      categoryType: 2,
    },
  ];

  treeData: any = [];

  defaultIndex = 0;
  show = false;
  selcteValue = [];

  name = "";
  loading = false;

  @Watch("defaultValue", { deep: true, immediate: true })
  onParamsChange() {
    this.name = this.defaultValue.categoryName || "全部分类";
    if (this.isMultiStore && this.defaultValue.storeName) {
      let storeName = this.defaultValue.storeName;
      if (storeName.length > 2) {
        storeName = `${storeName.slice(0, 2)}`;
      }
      this.name = `${storeName}-${this.name}`;
    }
  }
  openPop() {
    this.defaultIndex = 0;

    this.initData();

    this.show = true;
  }
  onChange(picker, value, index) {
    console.log("当前值", picker, value, index);
    this.defaultIndex = index;
    this.selcteValue = value;
  }

  popupClose() {
    this.show = false;
  }

  confirmFnMulti() {
    const values = this.selcteValue.filter((item) => item !== "全部");
    const select = {
      categoryName: "全部分类",
      categoryId: "all",
      storeId: "",
      storeName: "",
    };
    const first = this.treeData.find((item) => item.categoryName === values[0]);
    if (values.length === 1 && !["1", "0"].includes(first.categoryId)) {
      select.storeName = first.categoryName;
      select.storeId = first.categoryId;
    }
    if (values.length === 2) {
      const second = first.children.find(
        (item) => item.categoryName === values[1]
      );
      select.categoryName = second.categoryName;
      select.categoryId = second.categoryId;
      select.storeName = first.categoryName;
      select.storeId = first.categoryId;
    }

    if (values.length === 3) {
      const second = first.children.find(
        (item) => item.categoryName === values[1]
      );
      select.categoryName = second.children.find(
        (item) => item.categoryName === values[2]
      ).categoryName;
      select.categoryId = second.children.find(
        (item) => item.categoryName === values[2]
      ).categoryId;
      select.storeName = first.categoryName;
      select.storeId = first.categoryId;
    }
    this.$emit("confirm", select);
    this.popupClose();
  }

  confirmFn() {
    if (this.isMultiStore) {
      this.confirmFnMulti();
      return;
    }
    const values = this.selcteValue.filter((item) => item !== "全部");
    const select = { categoryName: "全部分类", categoryId: "all" };
    const first = this.treeData.find((item) => item.categoryName === values[0]);
    // if (values.length === 1) {
    //   select.categoryName = first.categoryName;
    //   select.categoryId = first.categoryId;
    // }
    if (values.length === 2) {
      const second = first.children.find(
        (item) => item.categoryName === values[1]
      );
      select.categoryName = second.categoryName;
      select.categoryId = second.categoryId;
    }

    if (values.length === 3) {
      const second = first.children.find(
        (item) => item.categoryName === values[1]
      );
      select.categoryName = second.children.find(
        (item) => item.categoryName === values[2]
      ).categoryName;
      select.categoryId = second.children.find(
        (item) => item.categoryName === values[2]
      ).categoryId;
    }
    this.$emit("confirm", select);
    this.popupClose();
  }
  async setOptions() {
    const { data } = await getGoodsFileCategory(
      {
        storeId: this.companyId,
        isTree: 1,
      },
      false
    );

    data.map((item: any) => {
      if (!item.children) {
        item.children = [];
      }
      if (item.categoryType === 1) {
        this.shopTreeData[0].children.push(item);
      } else {
        this.weidianTreeData[0].children.push(item);
      }
    });

    console.log(this.treeData, "*********");

    this.shopTreeData.forEach((item) => {
      item.children.forEach((it) => {
        if (!it.categoryId || !it.children) return;

        it.children.unshift({
          categoryId: it.categoryId,
          categoryName: "全部",
          categoryType: it.categoryType,
        });
      });
    });
    this.weidianTreeData.forEach((item) => {
      item.children.forEach((it) => {
        if (!it.categoryId || !it.children) return;

        it.children.unshift({
          categoryId: it.categoryId,
          categoryName: "全部",
          categoryType: it.categoryType,
        });
      });
    });
  }

  getTreeData(data: Array<any>, categoryType) {
    data.forEach((item: any) => {
      item.categoryId = item.storeId;
      item.categoryName = item.storeName;
      item.children = [
        {
          categoryId: item.categoryId,
          categoryName: "全部",
          categoryType: categoryType,
        },
      ];
      if (item.categoryList) {
        item.children = item.children.concat(item.categoryList);
      }

      item.children.forEach((cItem) => {
        cItem.children = [
          {
            categoryId: cItem.categoryId,
            categoryName: "全部",
            categoryType: categoryType,
          },
        ];
        if (cItem.subList) {
          cItem.children = cItem.children.concat(cItem.subList);
        }
      });
    });
    return data;
  }

  async setOptionsShop() {
    const params = {
      storeList: this.multiStoreList.map((item) => {
        return { storeId: item };
      }),
      isTree: 1,
    };

    // 门店
    const resOffline = await getStoreOfflineCategoryShop(params, false);
    const offlineData = this.getTreeData(resOffline.data, 1);
    this.shopTreeData = this.shopTreeData.concat(offlineData);

    // 微店
    const resIngredient = await getStoreIngredientCategoryShop(params, false);
    const ingredientData = this.getTreeData(resIngredient.data, 2);
    this.weidianTreeData = this.weidianTreeData.concat(ingredientData);
  }

  initData() {
    if (this.dimension === "门店") {
      this.treeData = this.shopTreeData;
      // console.log("kkk", this.shopTreeData);
      this.selcteValue = ["门店商品", "全部", "全部"];
    } else {
      this.treeData = this.weidianTreeData;
      // console.log("kkk", this.weidianTreeData);
      this.selcteValue = ["微店商品", "全部", "全部"];
    }
  }

  mounted() {
    setTimeout(async () => {
      this.loading = true;
      if (this.isMultiStore) {
        await this.setOptionsShop();
      } else {
        await this.setOptions();
      }
      this.loading = false;
      this.initData();
    }, 1000);
  }
}
